import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { InventoryDialogComponent } from '../inventory-dialog/inventory-dialog.component';
import { Store } from '@ngrx/store';
import { selectCountsState } from '@app/modules/counts/store/selectors/counts.selectors';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-excel',
  templateUrl: './excel.component.html',
  styleUrls: ['./excel.component.scss']
})
export class ExcelComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;

  public columns = [
    { columnDef: 'prdCode', header: 'Product Code' },
    { columnDef: 'prdNameEn', header: 'Product Description' },
    { columnDef: 'barcode', header: 'Barcode' },
    { columnDef: 'count', header: 'Count' },
    { columnDef: 'prdPackageUOM', header: 'Count Type' },
    { columnDef: 'prdCost', header: 'Cost per unit' },
    { columnDef: 'prdRetail', header: 'Retail Price' },
    { columnDef: 'totalCost', header: 'Total Cost' },
    { columnDef: 'totalRetail', header: 'Total Retail' },
    { columnDef: 'minQty', header: 'MSL' },
    { columnDef: 'category', header: 'Category' },
    { columnDef: 'areas', header: 'Areas' },
  ];

  public headers = this.columns.map(item => item.header);
  private id;
  public sortedData = [];
  public dataSource: any;
  public inventory$;
  public displayedColumns = this.columns.map(c => c.columnDef);
  public subs: SubSink = new SubSink;
  public isLoading: boolean = true;

  constructor(
    public _inventory: InventoryService,
    private _dialogRef: MatDialogRef<InventoryDialogComponent>,
    private _router: Router,
    private store$: Store
  ) {
    this.subs.add(this.store$.select(selectCountsState).subscribe(res => this.id = res.currentId));
    this.store$.dispatch(CountsActions.loadExcel({ invID: this.id, active: 'prdNameEn', direction: 'asc' }));
   }

  ngOnInit(): void {
    this.subs.add(this.store$.select(selectCountsState).subscribe(({ currentInventory, isLoading })=> { 
      this.dataSource = currentInventory.invItems;
      this.inventory$ = currentInventory.inv;
      this.isLoading = isLoading;
    }));
  }

  reorder(minQty, count) {
    let total = minQty - count;
    if (total < 0) {
      return 0;
    } else {
      return total;
    }
  }

  sortData(sort: Sort) {
    const data = this.dataSource.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'prdCode': return this.compare(a.prdCode, b.prdCode, isAsc);
        case 'prdNameEn': return this.compare(a.prdNameEn, b.prdNameEn, isAsc);
        case 'barcode': return this.compare(a.prdSKU, b.prdSKU, isAsc);
        case 'count': return this.compare(a.invitmCount, b.invitmCount, isAsc)
        case 'prdPackageUOM': return this.compare(
          a.prdCountTypeID == 1 ? a.prdPackageUOM : 'Each',
          b.prdCountTypeID == 1 ? b.prdPackageUOM : 'Each', isAsc
        );
        case 'prdCost': return this.compare(a.prdCost, b.prdCost, isAsc);
        case 'prdRetail': return this.compare(a.prdRetail, b.prdRetail, isAsc);
        case 'totalCost': return this.compare(a.prdCost * a.invitmCount, b.invitmCount * b.invitmCount, isAsc);
        case 'totalRetail': return this.compare(a.invitmCount * a.prdRetail, b.invitmCount * b.prdRetail, isAsc);
        case 'minQty': return this.compare(a.prdMinQty, a.prdMinQty, isAsc);
        case 'reorder': return this.compare(this.reorder(a.prdMinQty, a.invitmCount), a.prdMinQty, isAsc);
        case 'category': return this.compare(a.prdCategory, b.prdCategory, isAsc);
        case 'subcategory': return this.compare(a.prdSubCategory, b.prdSubCategory, isAsc);
        default: return 0;
      }
    });

    this.dataSource = this.sortedData;
  }

  compare(a: any | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  public onNavigate(prdID){
    this._dialogRef.close();
    this._router.navigate([`/products/${prdID}`]);
  }
  
}